import React, { useState } from 'react';
const Gallery = () => {
  const images = [
    { id: 2, src: '/images/booking/1.jpg', alt: 'Image 2' },
    { id: 3, src: '/images/booking/2.jpg', alt: 'Image 3' },
    { id: 4, src: '/images/booking/3.jpg', alt: 'Image 4' },
    { id: 5, src: '/images/booking/4.jpg', alt: 'Image 5' },
    { id: 6, src: '/images/booking/5.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/6.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/7.jpg', alt: 'Image 6' },
    { id: 1, src: '/images/booking/8.jpg', alt: 'Image 1' },
    { id: 6, src: '/images/booking/9.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/10.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/12.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/13.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/14.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/15.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/16.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/17.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/18.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/19.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/20.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/21.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/22.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/23.jpg', alt: 'Image 6' },
    { id: 6, src: '/images/booking/24.jpg', alt: 'Image 6' },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Open modal and set the clicked image
  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Show next image in the modal
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Show previous image in the modal
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };
  return (
<>
<section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">
                        <h1>Gallery</h1>
                    </div>
                </div>
            </section>
    <div className="gallery-container">
      <div className="gallery-grid">
        {images.map((image, index) => (
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className="gallery-image-item borderr"
            onClick={() => openModal(index)} // Open the modal on click
          />
        ))}
      </div>
      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay border">
          <button className="modal-close-button" onClick={closeModal}>
            &times;
          </button>
          <div className="modal-content-container ">
            <button className="modal-prev-button" onClick={prevImage}>
              &#10094;
            </button>
            <div className="modal-image-container">
              <img
                src={images[currentImageIndex].src}
                alt={images[currentImageIndex].alt}
                className="modal-image"
              />
            </div>
            <button className="modal-next-button" onClick={nextImage}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
</>
  );
};
export default Gallery;